import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext();

const ICONS = { success: '✅', error: '❌', warning: '⚠️', info: 'ℹ️' };
const COLORS = {
  success: { bg: '#d4edda', color: '#155724', border: '#a5d6a7' },
  error:   { bg: '#f8d7da', color: '#721c24', border: '#f5c6cb' },
  warning: { bg: '#fff3cd', color: '#856404', border: '#ffc107' },
  info:    { bg: '#d1ecf1', color: '#0c5460', border: '#bee5eb' },
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const toast = useCallback((message, type = 'info', duration = 4000) => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duration);
  }, []);

  const remove = id => setToasts(prev => prev.filter(t => t.id !== id));

  return (
    <ToastContext.Provider value={{ toast }}>
      {children}
      <div style={{
        position: 'fixed', bottom: '1.5rem', right: '1.5rem',
        display: 'flex', flexDirection: 'column', gap: '0.75rem',
        zIndex: 9999, maxWidth: 360, width: '90vw',
      }}>
        {toasts.map(t => {
          const c = COLORS[t.type] || COLORS.info;
          return (
            <div key={t.id} style={{
              background: c.bg, color: c.color,
              border: `1px solid ${c.border}`,
              borderRadius: 8, padding: '0.85rem 1rem',
              display: 'flex', alignItems: 'flex-start', gap: '0.6rem',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              animation: 'slideIn 0.25s ease',
            }}>
              <span style={{ fontSize: '1.1rem', flexShrink: 0 }}>{ICONS[t.type]}</span>
              <span style={{ flex: 1, fontSize: '0.9rem', lineHeight: 1.4 }}>{t.message}</span>
              <button onClick={() => remove(t.id)} style={{
                background: 'none', border: 'none', cursor: 'pointer',
                color: c.color, fontSize: '1rem', padding: 0, flexShrink: 0, opacity: 0.7,
              }}>×</button>
            </div>
          );
        })}
      </div>
      <style>{`@keyframes slideIn { from { opacity:0; transform:translateX(40px); } to { opacity:1; transform:translateX(0); } }`}</style>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
